class HulkCustomSingleUnitPrice extends HTMLElement{

    constructor(){
        super();
        this.salePrices = this.parentElement.querySelector('sale-price [data-hulkapps-line-price]');
        this.quantity = parseInt(this.closest('line-item').querySelector('input.quantity-input').value);
    }

    connectedCallback(){
        this.monitorPrices();
    }

    monitorPrices(){

        const config = {
        childList: true,      // Observe additions/removals of child nodes
        subtree: true,        // Observe all descendants of the target node
        };

        const callback = (mutations,observer) => {
            for (const mutation of mutations){
                if (mutation.target.querySelector('.discounted_price')) {
                    this.updateDiscountedUnitPrice();
                }
            }
        }

        const observer = new MutationObserver(callback);

        observer.observe(this.salePrices,config);
    }

    updateDiscountedUnitPrice(){
        const discountTotalEl = this.salePrices.querySelector('.discounted_price');
        if (discountTotalEl){
            const discountTotal = parseFloat(discountTotalEl.textContent.replace(/[^0-9.]/g,''));
            const formattedPrice = window.hulkapps.money_format.replace('{{amount}}', (discountTotal / this.quantity).toFixed(2)) + ` / unit`;
            if (!isNaN(discountTotal)){
                if (!this.querySelector('.discounted_price')){
                    const span = document.createElement('span');
                    span.classList.add('discounted_price');
                    span.textContent = formattedPrice;
                    this.appendChild(span);
                } else {
                    this.querySelector('.discounted_price').textContent = formattedPrice;
                }
                this.querySelector('.original_price').style.textDecoration = 'line-through';
            }
            
        }

        
    }
}

customElements.define('single-unit-price', HulkCustomSingleUnitPrice);